import { IconButton, IconButtonProps, Theme } from "@mui/material";
import { styled } from "@mui/material/styles";

interface CategoryButtonProps extends IconButtonProps {
    active?: boolean;
}

export const CategoryButton = styled(IconButton, { shouldForwardProp: (prop: string) => prop !== 'active' })<CategoryButtonProps>(({ theme, active }: { theme: Theme, active?: boolean }) => ({
    padding: 2,
    margin: "0 6px",
    borderRadius: "4px",
    background: active ? "rgba(102, 170, 255, 0.10)" : "transparent",
}));